import type {ValueOf} from '@myparcel-frontend/types';
import {BillingMethodId} from '@myparcel-frontend/types';

export default function useBilling() {
  const isPostPayment = (billingMethodId: ValueOf<typeof BillingMethodId>) => {
    const postPaymentBillingMethods = [
      BillingMethodId.Invoice,
      BillingMethodId.DirectDebit,
      BillingMethodId.PostPaymentDirectDebitPending,
    ];

    return postPaymentBillingMethods.includes(billingMethodId);
  };

  const isPrepaid = (billingMethodId: ValueOf<typeof BillingMethodId>) => {
    const prepaidBillingMethods = [BillingMethodId.Prepaid, BillingMethodId.PrePaymentDirectDebitPending];
    return prepaidBillingMethods.includes(billingMethodId);
  };

  return {
    isPostPayment,
    isPrepaid,
  };
}
